import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { copyTextToClipboard, showToast } from '~/utils'

const toPlainText = (value) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const el = document.createElement('div')
  el.innerHTML = String(value)

  return (el.textContent || '').replace(/\s+/g, ' ').trim()
}

const useCopyViewerText = (canEdit) => {
  const { t } = useTranslation()

  return useCallback(
    (text) => {
      if (canEdit) {
        return
      }

      const value = toPlainText(text)
      if (!value) {
        return
      }

      if (copyTextToClipboard(value)) {
        showToast(t('ui.copied-to-clipboard'), { variant: 'success' })
      } else {
        showToast(t('ui.copy-failed'), { variant: 'error' })
      }
    },
    [canEdit, t]
  )
}

export default useCopyViewerText
